import Alert from "@mui/material/Alert";

function AllertMessage({ message, status }) {
  return <Alert severity={status}>{message}</Alert>;
}

export default AllertMessage;
